import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./state/store/store";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Authentication from "./Authentication";
import 'typeface-roboto'
// import TwitterWidgetsLoader from 'twitter-widgets';

ReactDOM.render(
  // Root component needs to be wrapped in <Provider> so the components
  // can access the redux store
  <Provider store={store}>
    <Authentication />
  </Provider>,
  document.getElementById("root")
);

// Load twitter widget on window.twttr
// TwitterWidgetsLoader.load();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();